var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZenlist(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M59.0625 70.9375H15.5859L35.7031 35H79.2578L59.0625 70.9375Z",
    fill: "#1F2D3D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44.2578 45H0.78125L20.8984 9.0625H64.4531L44.2578 45Z",
    fill: "#C2CEDB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZenlist);
export default __webpack_public_path__ + "static/media/zenlist.5b4a797a3a5663ce7c9735deea1de51d.svg";
export { ForwardRef as ReactComponent };